"use client";

import { Suspense } from "react";

import BlockchainPayment from "../../components/payment/BlockchainPayment";

export default function Pricing() {
  return (
    <section id="pricing" className="flex items-center flex-col mt-24 px-6 text-white pb-32">
      <Suspense
        fallback={
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" />
          </div>
        }
      >
        <BlockchainPayment />
      </Suspense>
    </section>
  );
}
